import { ZMG_TOAST_CHANNEL } from "./BroadcastChannelToastTypes";
import { getParentInfo } from "@iframe-widgets/message/getParentInfo";

let channel: BroadcastChannel | null = null;

async function getChannel(): Promise<BroadcastChannel> {
    if (channel) return channel;
    const parentInfo = await getParentInfo();
    channel = new BroadcastChannel(ZMG_TOAST_CHANNEL + parentInfo.dataLayerIframeId);
    return channel;
}

function postToast(type: string, message: string, description?: string) {
    getChannel().then(ch => ch.postMessage({ type, message, description }));
}

export const toast: {
    success: (message: string, description?: string) => void;
    error: (message: string, description?: string) => void;
    warning: (message: string, description?: string) => void;
    info: (message: string, description?: string) => void;
    message: (message: string, description?: string) => void;
} = {
    success: (message, description) => postToast("success", message, description),
    error: (message, description) => postToast("error", message, description),
    warning: (message, description) => postToast("warning", message, description),
    info: (message, description) => postToast("info", message, description),
    message: (message, description) => postToast("message", message, description),
}